"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommitNewPlayerAction = void 0;
class CommitNewPlayerAction {
    execute(playerManager, _blackjackState, _instant) {
        playerManager.commitNextAvailablePlayer();
    }
}
exports.CommitNewPlayerAction = CommitNewPlayerAction;
